import { configureStore } from '@reduxjs/toolkit'
import { authSlice } from './slices/authSlice'
import { projetoSlice } from './slices/projetoSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    projeto: projetoSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
